var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-and-pay"},[_c('policy-wizard',{staticClass:"h-full",attrs:{"party":_vm.party,"step":_vm.activeStep,"policy-no":_vm.policyNo,"auth-token":_vm.token,"account-type":_vm.accountType},on:{"update:step":function($event){_vm.activeStep=$event},"gotoPolicy":_vm.gotoPolicy,"signComplete":_vm.onSign,"payComplete":_vm.onPay}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }